import cloneDeep from "lodash/cloneDeep";
import isEqual from "lodash/isEqual";
import { DependencyList, EffectCallback, useEffect, useRef } from "react";

export const useDeepCompareEffect = (effect: EffectCallback, deps: DependencyList) => {
    const ref = useRef<DependencyList>();

    if (!isEqual(deps, ref.current)) {
        ref.current = cloneDeep(deps);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(effect, [ref.current]);
};
